// extracted by mini-css-extract-plugin
export default {"one-column":"ControlTagBinaryRating-module__one-column__rZJ8S","two-column":"ControlTagBinaryRating-module__two-column__x0QbA"};